<template>
  <div class="x-postcontent x-postcontent-0 clearfix">
    <div class="x-content-layout layout-item-0">
      <div class="x-content-layout-row">
        <div
          class="x-layout-cell layout-item-1"
          style="width: 100%"
          >
          <table class="x-article" style="width: 100%; ">
            <tbody>
              <tr>
                <td style="width: 100%; ">
                  <h1 class="header">Welkom bij Taxinummer</h1>
                </td>
              </tr>
            </tbody>
          </table>
          <br /><br />
          <p>
            <img
              width="388"
              height="198"
              alt="taxinummer"
              src="./../assets/images/taxinummerlogo.jpg"
              style="float: left; "
              class=""
              />
          </p>
          <br>
          <p>Taxinummer is een digitaal magazine boordevol verhalen over de taxi in Amsterdam en andere wereldsteden.</p>

          <p>Taxinummer werd van 2010 tot 2018 maandelijks uitgegeven in de vorm van een papieren magazine.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>

<script>
// @ is an alias to /src

export default {
  name: 'home',
}
</script>
